import { z } from "zod";

/** Largest value accepted by PostgreSQL's signed `bigint` type. */
export const POSTGRES_BIGINT_MAX = 9_223_372_036_854_775_807n;
const POSTGRES_BIGINT_MAX_TEXT = POSTGRES_BIGINT_MAX.toString();

/**
 * Catalog IDs are canonical positive decimal strings backed by PostgreSQL
 * `bigint` columns (see `bigintString` in schema/catalog.ts).
 */
export const catalogIdSchema = z
  .string()
  .regex(/^[1-9][0-9]*$/, "Invalid catalog id")
  .refine(
    (value) =>
      value.length < POSTGRES_BIGINT_MAX_TEXT.length ||
      (value.length === POSTGRES_BIGINT_MAX_TEXT.length && value <= POSTGRES_BIGINT_MAX_TEXT),
    "Catalog id exceeds bigint range",
  );

export function isCatalogId(value: unknown): value is string {
  return catalogIdSchema.safeParse(value).success;
}
